<template>
  <div class="personal-outer-wrapper">
    <transition name="fade">
      <change-timezone-popup
        v-if="showChangeTimezonePopup"
        class="timezone-popup"
        :old-timezone="userTimezone"
        @change-timezone="handleUserTimezoneChange()"
        @close="showChangeTimezonePopup = false"
      />
    </transition>
    <transition name="fade">
      <holidays-days-left v-if="showHolidayDaysLeftPopup" :team-id="holidaysPopupTeamId" @close="showHolidayDaysLeftPopup = false" />
    </transition>
    <transition name="fade">
      <schedule-leave-prevent-popup
        v-if="leavePopupShow"
        @close="closeLeavePopup"
        @save-schedule="saveSchedulePopup"
        @dismiss-schedule="dismissSchedulePopup"
      />
    </transition>
    <transition name="fade">
      <cancel-confirm-popup v-if="cancelConfirmPopupShow" @close="closeCancelConfimPopup" @confirm="cancelConfirmed" />
    </transition>
    <div v-if="userId == -1" class="personal-header">
      <h4 />
    </div>
    <div v-else-if="ifPersonalCalendar" class="personal-header">
      <div class="header-button-left" @click="pushBackToCalendar">
        <img class="left-arrow" src="@/assets/_desktop/_shared/arrow_back.svg" />
        <a class="back">{{ $t('back') }}</a>
      </div>
      <div class="userHeader">
        <img
          class="avatar"
          :style="{
            background: getAvatar(teamMate).slice(-4) === '.svg' ? (teamMate.color ? teamMate.color : '#D1D4F0') : 'unset',
          }"
          :src="getAvatar(teamMate)"
        />
        <p class="teamMateFullName">
          {{ teamMate.name }}
          <span v-if="ifCurrentUser" class="you">{{ '(' + $t('you') + ')' }}</span>
        </p>
      </div>
      <div class="follow" @click="changeFollowing">
        <img :key="starKey + 'followStar'" :src="require('@/assets/_desktop/_shared/fav' + (isFollowed ? '-active.svg' : '.svg'))" />
      </div>
    </div>
    <div v-else class="personal-header">
      <h4>{{ $t('yourWorkingSchedule') }}</h4>
    </div>
    <div class="personal-content">
      <div class="calendar-outer-wrapper">
        <div class="calendar-header">
          <div class="c-h-b-left">
            <button
              class="clavo-button secondary today"
              :class="{ 'clavo-button-inactive': todayIsDisplayed }"
              @click="changeDisplay(moment().tz(userTimezone).toDate())"
            >
              {{ $t('today') }}
            </button>
            <a class="prev" @click.prevent="changeDisplay(moment(startDate).tz(userTimezone).subtract(amountOfDays, 'days').toDate())">
              <img src="@/assets/_desktop/_calendars/cal-arrow.svg" alt="" />
            </a>
            <a class="next" @click.prevent="changeDisplay(moment(startDate).tz(userTimezone).add(amountOfDays, 'days').toDate())">
              <img src="@/assets/_desktop/_calendars/cal-arrow.svg" alt="" />
            </a>
            <date-picker2 v-model="startDate" class="noSelect date-pick" :timezone="userTimezone" @input="changeDisplay" />
          </div>

          <!-- <div 
            v-if="isMyPersonal"
            class="c-h-b-right"
          >
            <button 
              class="clavo-button primary"
              :class="{ 'clavo-button-inactive': (!anyEntryChanged || submittingEntries || ifSelectWeekShow)}"
              @click="submitSchedule"
            >
              {{ $t('save') }}
            </button>
          </div> -->
        </div>
        <week-personal
          :ref="'week'"
          :amount-of-days="amountOfDays"
          :user-timezone="userTimezone"
          :is-my-personal="isMyPersonal"
          :submitting-entries="submittingEntries"
          :any-entry-changed="anyEntryChanged"
          @hide-select-week="selectWeekShow = false"
          @change-work-hours="changeWorkHours"
          @setAnyEntryChanged="setAnyEntryChanged"
          @cancel-clicked="cancelConfirmPopupShow = true"
        />
      </div>

      <PersonalSummary
        ref="summary"
        :key="summaryKey + 'summary'"
        class="summary"
        :holiday-info="holidayInfo"
        :hours-scheduled="workScheduled"
        :hours-total="40"
        :is-my-personal="isMyPersonal"
      />
    </div>
    <div v-if="submittingEntries" class="navigation-lock" />
  </div>
</template>
<script>
import ChangeTimezonePopup from '@/components/Calendar/ChangeTimezonePopup'
import PersonalSummary from '@/components/Personal/Summary'
import moment from 'moment-timezone'
import DatePicker2 from '@/components/UI/DatePicker2/DatePicker2'
import WeekPersonal from '@/components/Personal/WeekPersonal'
import Parse from 'parse'
import EventBus from '@/EventBus'
import Constants from '@/components/Constants'
import ParseFunctions from '@/components/ParseFunctions'
import HolidaysDaysLeft from '@/components/Personal/HolidaysDaysLeft'
import ScheduleLeavePreventPopup from '@/components/Personal/ScheduleLeavePreventPopup'
import CancelConfirmPopup from '@/components/Personal/CancelConfirmPopup'
import isEmpty from 'lodash/isEmpty'
import { getNextWeekStartFromDate, getWeekStartFromDate } from '../../../clavo-shared/functions/time.js'
import { calculateStoredEntriesKey } from '../../../clavo-shared/functions/entriesFetchTools'

export default {
  components: {
    ChangeTimezonePopup,
    PersonalSummary,
    DatePicker2,
    WeekPersonal,
    HolidaysDaysLeft,
    ScheduleLeavePreventPopup,
    CancelConfirmPopup,
  },
  mixins: [Constants, ParseFunctions],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      componentName: 'Personal',
      userId: -1,
      startDate: null,
      endDate: null,
      amountOfDays: 7,
      userStartWeek: null,
      userTimezone: Parse.User.current().get('timezone'),
      summaryKey: 0,
      workScheduled: { total: 0 },
      clock12: true,
      showHolidayDaysLeftPopup: false,
      anyEntryChanged: false,
      submittingEntries: false,
      submittingEntriesTimeout: 10000,
      submittingEntriesTimeoutId: null,
      teamMate: { avatarIndex: 1, name: '', isFollowed: false },
      starKey: 0,
      todayIsDisplayed: true,
      summaryLoaded: true,
      holidayInfo: {},
      isMyPersonal: false,
      selectWeekShow: false,
      leavePopupShow: false,
      leavePopupWasShown: false,
      savedLink: {},
      isFollowed: false,
      holidaysPopupTeamId: null,
      cancelConfirmPopupShow: false,
      showChangeTimezonePopup: false,
    }
  },

  computed: {
    ifCurrentUser() {
      return !this.$route.query.userId || this.$route.query.userId === Parse.User.current()._getId()
    },
    ifPersonalCalendar() {
      if (this.$route.query && this.$route.query.userId) {
        return true
      } else if (this.$route.query) {
        return false
      }
      return false
    },
    ifSelectWeekShow() {
      return this.$refs['week'].selectWeekShow
    },
  },

  watch: {
    startDate: function () {
      let today = moment().tz(this.userTimezone).startOf('day')
      this.todayIsDisplayed = today.isSameOrAfter(moment(this.startDate), 'day') && today.isSameOrBefore(moment(this.startDate).add(6, 'days'), 'day')
    },
    $route: async function (to, from) {
      // it runs on route change
      // update the entries
      if (this.$store.state.preventScheduleLeave) return

      this.setStartEndFromRoute(this.$route.query)

      if (from.query.userId && !to.query.userId) this.userId = Parse.User.current()._getId()
      else if (!from.query.userId && to.query.userId) this.userId = to.query.userId

      this.changeDisplayFromLink(this.startDate)
    },
    anyEntryChanged: function () {
      this.$store.commit('setPreventScheduleLeave', this.anyEntryChanged)
    },
    submittingEntries: function () {
      this.$store.commit('setShowProgressBar', this.submittingEntries)
    },
  },

  async updated() {
    if (this.$route.query && this.$route.query.userId) {
      this.userId = this.$route.query.userId
    } else if (this.$route.query) {
      this.userId = null
    }
    this.isMyPersonal = this.ifCurrentUser
  },

  mounted() {
    EventBus.$on('leave-prevent', this.leavePrevent)
    EventBus.$on('updateTeamMateInPersonal', this.updateTeamMateInPersonal)
    EventBus.$on('updateHolidayInfo', this.formatHolidayInfo)
    EventBus.$on('parse-submitEntries', this.handleSubmitEntriesResult)
    EventBus.$on('submit-clicked', this.submitSchedule)
    EventBus.$on('open-change-timezone-switch-popup', this.openChangeTimezonePopup)
  },

  async created() {
    if (this.$route.query && this.$route.query.userId) {
      this.userId = this.$route.query.userId
    }

    this.isMyPersonal = this.ifCurrentUser
    this.initHolidayInfo()

    EventBus.$on('open-holidays-popup', this.openHolidaysPopup)

    const userSettings = this.$store.state.userSettings
    if (!userSettings) {
      let res = await this.userSettingsCLAPI()
      if (res.status === 'ok') {
        userSettings = res.settings
      } else {
        this.showServerError(res)
      }
    }
    this.userTimezone = userSettings.timezone
    if (Parse.User.current().get('timezone') != this.userTimezone) {
      Parse.User.current().set('timezone', this.userTimezone)
      Parse.User.current().save()
    }
    this.clock12 = !userSettings['is-24h']

    this.userStartWeek = userSettings['week-start'] ? userSettings['week-start'] : 'Monday'

    // if (userSettings.timezone) {
    this.setStartEndFromRoute(this.$route.query)

    if (Object.keys(this.params).length !== 0 && this.params.teamMate) {
      this.teamMate = this.params.teamMate
      this.isFollowed = this.teamMate.isFollowed
    }
  },

  beforeDestroy() {
    this.$store.commit('clearTempTimeOffChanges')
    EventBus.$off('open-holidays-popup', this.openHolidaysPopup)
    EventBus.$off('leave-prevent', this.leavePrevent)
    EventBus.$off('updateTeamMateInPersonal', this.updateTeamMateInPersonal)
    EventBus.$off('updateHolidayInfo', this.formatHolidayInfo)
    EventBus.$off('parse-submitEntries', this.handleSubmitEntriesResult)
    EventBus.$off('submit-clicked', this.submitSchedule)
    EventBus.$off('open-change-timezone-switch-popup', this.openChangeTimezonePopup)

    if (this.isMyPersonal && !isEmpty(this.$store.state.copiedEntry)) {
      this.saveLastTeamAndLocation()
    }
  },
  methods: {
    async saveLastTeamAndLocation() {
      let lastUsedTeamId = this.$store.state.copiedEntry.teamId
      let lastUsedLocationId = this.$store.state.copiedEntry.location.id || this.$store.state.copiedEntry.location.objectId

      let save = false
      let res

      if (lastUsedTeamId != this.$store.state.userSettings['last-used-team-id']) {
        save = true
        Parse.User.current().set('last-used-team-id', lastUsedTeamId)
        res = await this.setUserSetting('last-used-team-id', lastUsedTeamId)
        if (res.status === 'ok') {
          this.$store.commit('setOneUserSetting', { name: 'last-used-team-id', value: lastUsedTeamId })
        }
      }

      if (lastUsedLocationId != this.$store.state.userSettings['last-used-location-id']) {
        save = true
        Parse.User.current().set('last-used-location-id', lastUsedLocationId)
        res = await this.setUserSetting('last-used-location-id', lastUsedLocationId)
        if (res.status === 'ok') {
          this.$store.commit('setOneUserSetting', { name: 'last-used-location-id', value: lastUsedLocationId })
        }
      }

      if (save) Parse.User.current().save()
    },
    openHolidaysPopup(teamId, force = false) {
      if (!force && this.$store.state.teamsNotToAskAboutLeaveDays.includes(teamId)) return
      this.holidaysPopupTeamId = teamId
      this.showHolidayDaysLeftPopup = true
    },
    updateTeamMateInPersonal(teamMateDetails) {
      this.teamMate = teamMateDetails
      this.isFollowed = teamMateDetails.isFollowed
    },
    openChangeTimezonePopup() {
      this.showChangeTimezonePopup = true
    },
    handleUserTimezoneChange() {
      this.userTimezone = Parse.User.current().get('timezone')

      if (this.$route.query && this.$route.query.date)
        this.startDate = moment.tz(this.$route.query.date, 'DD-MMM-YYYY', this.userTimezone).startOf('day').toDate()
      else this.startDate = new Date()

      this.endDate = moment(this.startDate).add(this.amountOfDays, 'days').toDate()

      setTimeout(() => {
        EventBus.$emit('timezone-changed')
      }, 100)
    },
    formatHolidayInfo(teams) {
      if (!teams) return
      let formattedHolidayInfo = {}
      for (const team of teams) {
        formattedHolidayInfo[team.teamId] = team.holiday
      }
      this.holidayInfo = formattedHolidayInfo
    },
    initHolidayInfo() {
      if (this.$store.state.holidayInfo && this.$store.state.holidayInfo[this.userId]) {
        this.formatHolidayInfo(this.$store.state.holidayInfo[this.userId].holidayInfo)
      } else {
        let initialHolidayInfo = {}
        for (const team of this.$store.state.teams) {
          initialHolidayInfo[team.teamId] = { [moment().format('YYYY')]: { used: 0, limit: undefined } }
        }
        this.holidayInfo = initialHolidayInfo
      }
    },
    closeLeavePopup() {
      this.leavePopupShow = false
    },
    async saveSchedulePopup() {
      await this.submitSchedule()
    },
    dismissSchedulePopup() {
      this.$store.commit('clearTempTimeOffChanges')
      this.closeLeavePopup()
      this.routerHandling()
    },
    routerHandling() {
      this.$store.commit('setPreventScheduleLeave', false)
      if (this.savedLink.to === 'logout') {
        EventBus.$emit('logout')
      } else if (this.savedLink instanceof Date && !isNaN(this.savedLink.valueOf())) {
        this.changeDisplay(this.savedLink)
      } else {
        this.$router.push(this.savedLink.to)
      }
    },
    leavePrevent(to) {
      this.leavePopupShow = true
      this.savedLink = to
    },
    cancelConfirmed() {
      EventBus.$emit('cancel-confirmed')
      this.$store.commit('setPreventScheduleLeave', false)
      this.cancelConfirmPopupShow = false
    },
    closeCancelConfimPopup() {
      this.cancelConfirmPopupShow = false
    },
    checkIfTodayDisplayed() {
      return true
    },
    setTeamInSummary(team) {
      this.$refs.summary.setTeam(team)
    },
    async changeFollowing() {
      let res
      if (this.isFollowed) {
        res = await this.removeFromWatchlist(this.teamMate.userId)
      } else {
        res = await this.addToWatchlist(this.teamMate.userId)
      }
      if (res.status === 'ok') {
        this.teamMate['isFollowed'] = !this.isFollowed
        this.isFollowed = !this.isFollowed
      } else {
        this.showServerError(res)
      }

      this.starKey++
    },
    setAnyEntryChanged(value) {
      this.anyEntryChanged = value
    },
    changeWorkHours(hours) {
      // todo
      this.workScheduled = hours
    },
    setStartEndFromRoute(query) {
      if (query.date) {
        this.startDate = moment.tz(query.date, 'DD-MMM-YYYY', this.userTimezone).startOf('day').toDate()
      } else {
        // if there's no date in url, set startDate to default, i.e. today
        this.startDate = new Date()
      }

      this.endDate = moment(this.startDate).add(this.amountOfDays, 'days').toDate()
    },
    async submitSchedule() {
      // todo cast entriesy
      this.submittingEntries = true
      this.$refs['week'].schedulePopup.active = false

      if (this.leavePopupShow) {
        this.closeLeavePopup()
        this.leavePopupWasShown = true
      }

      let entries = []
      let entriesRef = this.$refs['week'].entries
      for (let i = 0; i < entriesRef.length; i++) {
        let entryRef = entriesRef[i]
        if (entryRef.changed) {
          let ent = {
            start: entryRef.start,
            end: entryRef.end,
            type: entryRef.type,
            teamId: entryRef.teamId,
          }
          if (entryRef.location) {
            ent.locationId = entryRef.location.id ? entryRef.location.id : entryRef.location.objectId
          }
          if (entryRef.id && entryRef.id.substr(0, 4) !== 'brak') ent.entryId = entryRef.id
          if (entryRef.timezone) {
            ent.timezone = entryRef.timezone
          } else {
            if (this.userTimezone) ent.timezone = this.userTimezone
          }
          if (entryRef.deletedAt || entryRef.isDeleted) ent.isDeleted = true
          if (entryRef.comment != undefined) ent.comment = entryRef.comment
          if (!(entryRef.id.substr(0, 4) === 'brak' && ent.isDeleted === true)) entries.push(ent)
        }
      }
      let weekStart = this.$refs['week'].startDate
      let weekEnd = this.$refs['week'].endDate

      this.submittingEntriesTimeoutId = setTimeout(
        function () {
          this.submittingEntries = false
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('submittingTimeout'),
            error: true,
          })
        }.bind(this),
        this.submittingEntriesTimeout,
      )

      await this.submitEntries(entries, weekStart, weekEnd, this.userTimezone, this.userId)
    },

    async handleSubmitEntriesResult(res) {
      clearTimeout(this.submittingEntriesTimeoutId)
      this.submittingEntries = false
      const userId = this.userId || Parse.User.current()._getId()

      if (res.status === 'ok') {
        this.anyEntryChanged = false
        this.$store.commit('setPreventScheduleLeave', false)
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('scheduleSubmitted'),
        })
        // update stored user's week schedule
        let startDate = getWeekStartFromDate(this.startDate, this.userStartWeek, this.userTimezone)
        let endDate = getNextWeekStartFromDate(this.startDate, this.userStartWeek, this.userTimezone)
        const valsToCalculateKey = {
          start: startDate.clone().utc().format('DD/MM/YYYY HH:mm:ss'),
          end: endDate.clone().utc().format('DD/MM/YYYY HH:mm:ss'),
          userId: userId,
        }
        const key = calculateStoredEntriesKey(valsToCalculateKey)
        await this.$refs['week'].fetchAndUpdateStore(startDate, endDate, userId, key)
        let shouldRequestEntries = false // to prevent double 'entries' request
        await this.$refs['week'].load(userId, shouldRequestEntries)
        this.$refs['week'].hideDeadlineMissedBar()

        this.$store.commit('clearTempTimeOffChanges')

        if (this.leavePopupWasShown) {
          this.leavePopupWasShown = false
          this.routerHandling()
        }
      } else if (res.status === 'warning') {
        for (const errorEntry of res.errorEntries) {
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('errors.' + errorEntry.error),
            error: true,
          })
        }
      } else {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('error'),
          error: true,
        })
      }
    },
    async changeDisplayFromLink(date) {
      if (!this.summaryLoaded) return
      this.summaryLoaded = false

      this.startDate = getWeekStartFromDate(date, this.userStartWeek, this.userTimezone).toDate()
      this.endDate = getNextWeekStartFromDate(date, this.userStartWeek, this.userTimezone).toDate()

      this.$refs['week'].schedulePopup.active = false
      this.$refs['week'].startDate = this.startDate
      this.$refs['week'].endDate = this.endDate

      await this.$refs['week'].load(this.userId)

      this.summaryLoaded = true
    },

    /**
     * Sets startDate to the beginning of the week of the provided date and updates view
     * @param {Date} date
     * @return {Promise<void>}
     */
    async changeDisplay(date) {
      if (this.$store.state.preventScheduleLeave) {
        this.leavePopupShow = true
        this.savedLink = date
        return
      }
      this.anyEntryChanged = false

      this.$refs.week.selectWeekShow = false
      if (!this.summaryLoaded) return
      this.summaryLoaded = false

      this.startDate = getWeekStartFromDate(date, this.userStartWeek, this.userTimezone).toDate()
      this.endDate = getNextWeekStartFromDate(date, this.userStartWeek, this.userTimezone).toDate()

      this.$refs['week'].schedulePopup.active = false
      this.$refs['week'].startDate = this.startDate
      this.$refs['week'].endDate = this.endDate

      await this.$refs['week'].load(this.userId)

      let query = {
        date: moment.tz(date, this.userTimezone).format('DD-MMM-YYYY'),
      }
      if (this.userId) query.userId = this.userId
      if (this.$route.query.teamId) query.teamId = this.$route.query.teamId
      if (this.$route.query.watchlistId) query.watchlistId = this.$route.query.watchlistId
      await this.$router.push({
        hash: this.userId ? 'TeamMate' : this.componentName,
        path: '/',
        query: query,
      })

      this.summaryLoaded = true
    },
    async pushBackToCalendar() {
      let query = {}
      if (this.$route.query.date) query.date = this.$route.query.date
      if (this.$route.query.teamId) query.teamId = this.$route.query.teamId
      await this.$router.push({
        path: '/',
        query: query,
        hash: this.$route.query.teamId ? 'Calendar' : 'Followed',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.personal-outer-wrapper {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 71px minmax(0, 1fr); // 1px for border

  .timezone-popup {
    position: absolute;
  }

  .personal-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 270px 0 18px;
    margin: 0 0 0 0;
    border-bottom: 1px solid $athens-gray;
    overflow: hidden;
    @include respond-below(sm) {
      padding: 0 10px;
    }
    h4 {
      font-size: 20px;
      line-height: 20px;
    }
    button:first-child {
      margin-right: 20px;
    }

    .userHeader {
      display: flex;
      align-items: center;
      word-break: break-word;

      .avatar {
        margin-right: 10px;
      }
    }

    .teamMateFullName {
      color: $black;
      font-family: $bold;
      font-size: 20px;
      letter-spacing: 0.3px;
      line-height: 20px;
      .you {
        font-family: $bold;
        color: $bluebell;
      }
    }

    .follow {
      margin-left: 10px;
      height: 40px;
      width: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &:hover {
        background-color: $white-lilac;
      }
    }

    .header-button-left {
      height: 40px;
      padding: 0 12px;
      display: flex;
      align-items: center;
      display: flex;
      justify-items: flex-start;
      cursor: pointer;
      margin-right: 18px;
      &:hover {
        background-color: $white-lilac;
      }

      .left-arrow {
        margin-top: 1px;
      }

      a {
        font-size: 16px;
        color: $blue;
        font-family: $bold;
        margin-left: 8px;
        @include respond-below(md) {
          display: none;
        }
      }
    }
  }
  .personal-content {
    display: flex;
    // grid-template-columns: 1fr 300px;
    // grid-template-rows: 1fr;
    height: 100%;
  }
  .navigation-lock {
    position: fixed;
    width: 125vw;
    height: 125vh;
    background-color: white;
    opacity: 0;
    left: 0;
    top: 0;
    z-index: 999;
    cursor: progress;
  }
}
.calendar-outer-wrapper {
  flex: 4;
  height: 100%;
  display: grid;
  align-content: start;
  grid-template-rows: auto 1fr; // 71px previous setting for heading part
  @include respond-below(sm) {
    grid-template-rows: auto 1fr;
  }
  .calendar-header {
    padding: 15px 18px;
    border-bottom: 1px solid $athens-gray;
    display: flex;
    justify-content: space-between;

    @include respond-below(sm) {
      padding: 15px 10px;
      flex-direction: column;
      justify-content: flex-start;
    }

    .c-h-b-left {
      display: flex;
      .date-pick {
        display: flex;
        align-items: center;
        &:hover {
          background-color: $white-lilac;
        }
        margin-top: -10px;
        margin-bottom: -10px;
      }
      .prev {
        transform: scaleX(-1);
      }
      .next {
        margin-right: 10px;
      }
      .prev,
      .next {
        cursor: pointer;
        line-height: 20px;
        display: flex;
        align-items: center;
        padding: 0 12px 0 14px;
        &:focus {
          outline: none;
        }
        &:focus-visible {
          outline: 2px solid rgba($blue, 0.3);
        }
        &:hover {
          background-color: $white-lilac;
        }
      }
    }
    .c-h-b-right {
      @include respond-below(sm) {
        padding: 0 5px;
        button {
          width: 100%;
        }
      }
    }
    .noSelect {
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
    }
    .today {
      min-width: 90px;
      margin-right: 18px;
      @include respond-below(md) {
        text-indent: -9999em;
        margin-right: 10px;
        width: 40px;
        min-width: auto;
        background: url(~@/assets/_desktop/_calendars/calendar-today-active.svg) no-repeat center center;
        border: 0;
        &.clavo-button-inactive {
          background-image: url(~@/assets/_desktop/_calendars/calendar-today.svg);
        }
      }
    }
  }
}
</style>
